import { Loader2 } from 'lucide-react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';

export function EORoleRoute() {
  const { identity, isAuthInitialized, isAuthenticating } = useAppSelector((s) => s.auth);

  if (!isAuthInitialized || isAuthenticating) {
    return (
      <div className="eo-shell" style={{ minHeight: '100vh', placeItems: 'center', display: 'grid' }}>
        <div className="flex flex-col items-center gap-3" style={{ color: 'var(--muted-foreground)' }}>
          <Loader2 className="h-8 w-8 animate-spin" />
          <span className="text-sm">Loading…</span>
        </div>
      </div>
    );
  }

  if (!identity) {
    return <Navigate to="/login" replace />;
  }

  if (identity.partnerRole !== 'eventOrganizer') {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
